import moment from 'moment';
/**
 * @param {Object[]} employeeIds
 * @param {Object[]} shifts
 * @returns {Array[String[]]}
 */
const generateBreaksHTMLTableRows = (employeeIds, shifts) => {
  const shiftsThisWeekCopy = [...shifts];

  // key - employee id, value - map
  const employeesObject = {};
  const numberOfBreaksInWeekObject = new Map([
    ['monday', 0],
    ['tuesday', 0],
    ['wednesday', 0],
    ['thursday', 0],
    ['friday', 0]
  ]);

  shiftsThisWeekCopy.forEach(shift => {
    const { employeeId, start, breakMinutes } = shift;
    const employeeInfo = employeeIds[parseInt(employeeId, 10)];

    if (!employeeInfo) {
      return;
    }

    const employeeName = employeeInfo.name || '';
    const dayOfWeek = moment(start).format('dddd').toLowerCase();
    // remove any break minutes, if any, from total amount worked

    if (employeesObject[employeeId] === undefined) {
      // use map since we want to preserve key order here
      let employeeMap = new Map([
        ['employeeId', employeeName],
        ['monday', 0],
        ['tuesday', 0],
        ['wednesday', 0],
        ['thursday', 0],
        ['friday', 0]
      ]);

      employeesObject[employeeId] = employeeMap;
    }

    let numberOfBreaksForDay = numberOfBreaksInWeekObject.get(dayOfWeek);
    const breakMinutesForDay = employeesObject[employeeId].get(dayOfWeek);
    const updatedMinutes = breakMinutesForDay + breakMinutes;

    if (breakMinutes > 0) {
      numberOfBreaksForDay += 1;
    }

    // update values in employee's map
    employeesObject[employeeId].set(dayOfWeek, updatedMinutes);
    // update number of breaks for day
    numberOfBreaksInWeekObject.set(dayOfWeek, numberOfBreaksForDay);
  });

  const numberOfBreaksRow = ['Total Number of Breaks Required', ...Array.from(numberOfBreaksInWeekObject.values())];
  let employeeRows = Object.values(employeesObject).map(map => Array.from(map.values()));

  // ensure the array is alphabetical order
  employeeRows.sort((emp1, emp2) => {
    // first item in the array is the employee's name
    const emp1Name = emp1[0];
    const emp2Name = emp2[0];
    const emp1LastName = emp1Name.split(' ')[1].toLowerCase();
    const emp2LastName = emp2Name.split(' ')[1].toLowerCase();

    if (emp1LastName < emp2LastName) return -1;
    if (emp1LastName > emp2LastName) return 1;
    return 0;
  });

  /**
   * currently each employee row is an array where the first value is their name and the other values are the number of break minutes per day
   * we need to format the break minutes value to say "X minutes"
   */
  const formattedEmployeeRows = employeeRows.map(row => {
    return row.map((column, index) => {
      return index === 0 ? column : `${column} minutes`;
    });
  });

  return [numberOfBreaksRow, ...formattedEmployeeRows];
};

export default generateBreaksHTMLTableRows;
